<template lang="he">
<div style="position: absolute; top: 0px; left: 50%; transform: translateX(-50%); width: 100%; max-width: 590px;">
    <div v-if="!continueClicked" style="position: absolute; left: 0; top: 0; width: 100%; height: 100vh; z-index: 10; background-color: rgba(0,0,0,0.9); display: flex; align-items: center; justify-content: center;">
        <iframe :src="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="width: 100%; max-width: 590px; max-height: 80vh; aspect-ratio: 16 / 9; display: block; margin: 0 auto;"></iframe>
        <button v-if="lang='he'" class="continueButton" @click="continueToPage">המשך</button>
    </div>
    <div class="background">
        <div class="row  align-items-center m-0" style="height: 20%">
            <div class="col-4 pe-0">
                <div class=" col-12 justify-content-start pe-0 my-1" @click="changeLanguage('en')" v-if="lang != 'en'">
                    <div class="languageChoice">ENGLISH</div>
                </div>
                <div class=" col-12 justify-content-start pe-0  my-1" @click="changeLanguage('ar')" v-if="lang != 'ar'">
                    <div class="languageChoice">العربية</div>
                </div>
                <div class=" col-12 justify-content-start pe-0  my-1" @click="changeLanguage('he')" v-if="lang != 'he'">
                    <div class="languageChoice">עברית</div>
                </div>

            </div>
            <div class=" col-4">
                <div class="text-center d-flex justify-content-center col-12 p-0">
                    <img src="../../static/img/EDMlogoBlack.png" alt="" style="width: 97px; top: 25px; position: relative;" />
                </div>
            </div>
            <div class=" col-4 " @click="showMenu">
                <div style="    position: absolute; left: 10px; bottom: -7px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class=" justify-content-center align-items-center pt-5" style="height: 60%; width: 270px;     margin: 0 auto;">
            <div class="text-center m-0" :class="{ english: isEnglish }" style="
          max-width: 360px;
          color: white;
          font-size: 20px;
          padding: 0px 10px 46px 10px;
          font-family: segoeui;
          font-style: italic;
        ">
                {{ translation.quote }}
                <div class="h1 text-center m-0 mt-3" style="
            font-family: segoeui;
            font-size: 16px;
            font-style: italic;
          ">
                    {{ translation.quoteName }}
                </div>
            </div>
        </div>
        <div class="row align-items-center m-0" style="height: 20% ;position: relative; top: 110px">
            <div class="col-4 p-0 buttonsAndArrows">
                <button class="buttonWhiteBorder buttonAdults btn" :class="{ noBold: isEnglish }" @click="startVisit">
                    {{ translation.adultTour }}
                </button>
            </div>
            <div class="col-4 p-0 buttonsAndArrows">
                <img src="../../static/img/arrowsSmall.png" alt="" class="arrowSmall">
                <audio ref="audio" controls class="mt-3 audioButton" v-if="lang == 'he'">
                    <source :src="audio1" />
                </audio>
            </div>
            <div class="col-4 p-0 buttonsAndArrows">
                <button class="buttonWhiteBorder buttonChildren btn" :class="{ noBold: isEnglish }" @click="startVisitChildren">
                    {{ translation.childrenTour }}
                </button>
            </div>
        </div>
    </div>
    <div style="min-height: 50vh; min-height: 50vh; display: flex; align-content: center; justify-content: center; align-items: center;">
        <div class="text-justify m-0 welcomeTextClass" :class="{ englishTitle: isEnglish }">
            <!-- <img src="../../static/img/soundIcon.png" alt="" style="width: 34px;"> -->
            <div class="mt-4 text-center" style="font-weight: bold; white-space: pre-line; text-align-last: center ">{{ translation.welcome }}</div>
            <br />
            {{ translation.welcomeText }}
        </div>
    </div>
    <div class="menu " ref="openMenu">
        <img src="../../static/img/cross.png" alt="" class="cross" @click="hideMenu" />
        <div style="height: 15%; color: white;" class="d-flex justify-content-center align-items-center">
            <img src="../../static/img/logoWhite.png" alt="" style="width: 97px; position: relative;" />
        </div>
        <Accordion />
    </div>
</div>
</template>

<script>
import Accordion from "./accordion";

export default {
    components: {
        Accordion,
    },
    data() {
        return {
            continueClicked: false,
            videoUrl: 'https://www.youtube.com/embed/HQOOva8IG3E?si=PDjlBuZI3MmzaCRc?rel=0',

            audio1: "https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/audioDigitalGuide%2F1%20%D7%91%D7%A8%D7%95%D7%9B%D7%99%D7%9D%20%D7%94%D7%91%D7%90%D7%99%D7%9D.MP3?alt=media&token=5a44bf5d-683f-4b08-9b3c-0053629a7dca",
            isEnglish: false,
            // langChange: "ENGLISH",
            lang: "he",
            title: "מוזיאון עין-דור",
            userName: "",
            translation: {
                welcome: "ברוכים הבאים למוזיאון עין-דור",
                toMuseum: "",
                adultTour: "סיור במוזיאון",
                childrenTour: "סיור ילדים",
                quote: "'ובְחֶשְכַת הַלַּיְל בְּלִי קֶשֶׁת וְשֶלַח עַל סוּס קַל עֱין דּוֹרָה בָּא שָׁאוּל הַמֶּלֶךְ'",
                quoteName: "(ש. טשרניחובסקי - 'בְּעֵין דּוֹר')",
                welcomeText: "זה המדריך הדיגיטלי המלווה את התצוגה במוזיאון והוא יסייע לכם לצאת למסע היכרות מרתק עם תצוגת הקבע שלנו. באמצעות הפריטים במוזיאון תתוודעו לקשר העמוק בין אדם לאדמה ובין אדם לאדם באזורנו, ותכירו את החזון ואת המטרות של המוזיאון. מרבית הממצאים מושאלים בהשאלת קבע מאוצרות המדינה באמצעות רשות העתיקות. התצוגה הארכיאולוגית מדגימה את העושר התרבותי של האזור, את היותו אזור מפגש בין תרבויות וזהויות שחיו בסמיכות לכל אורך ההיסטוריה וגם כיום, תרבויות שהצמיחו משנה סדורה של ערכים שמקצתם מלווה אותנו עד היום. אנו מזמינים אתכם להתבונן בפריטים בנחת, ברוגע ובקפידה, לקרוא עליהם כאן ולהפליג על מפרשי הדמיון למחוזות העבר. תוכלו למצוא במדריך מידע נוסף על נושאים, ממצאים וחפצים המעניינים אתכם.מאחלים לכם ביקור מרתק ומהנה. צוות המוזיאון ",
                aboutMuseum: "על המוזיאון",
                aboutPlace: "על המיקום",
                aboutExibithion: "על התצוגה",
                aboutMuseumText: "המוזיאון הארכיאולוגי בקיבוץ עין דור מהווה מרכז רב-תרבותי, חינוכי, חברתי וערכי, העוסק בזיקה בין האדם לנוף באזור עמק יזרעאל והגליל התחתון. המוזיאון הוקם בשנת 1986, על ידי חברי קיבוץ עין דור, כחלק מפרויקט ההנצחה של הקיבוץ וכבית אוספים לעתיקות שהתגלו באזור מאז עלה הקיבוץ על הקרקע בשנת 1948. חברי עין דור, שהיו אנשי תרבות, ידעו לזהות את שרידי העבר כבעלי ערך תרבותי והיסטורי וחינכו לאורם את דור הבנים. בשנת 1997 קיבל הכרה  על ידי משרד התרבות ומשרד החינוך להיות 'מוזיאון מוכר'. הנוף והאדם הם נושאי-העל של המוזיאון. התצוגה הארכיאולוגית נעה סביב שני הצירים; בין אדם לאדמה ובין אדם לאדם. התצוגה מתמקדת בנקודות המפגש הרבות המייחדות את הסביבה המקומית. ה'מפגשים' שהתרחשו בין האדם והסביבה במרחב שבין עמק יזרעאל לבין הגליל התחתון, התקיימו למן ראשית הופעת האדם באזור בתקופות הפרהיסטוריות ועד למאה ה-19 לספירה ולמעשה עד ימינו."
            }
        };
    },
    mounted() {
        localStorage.clear();
    },
    computed: {
        error() {
            return this.$store.getters.error;
        },
        loading() {
            return this.$store.getters.loading;
        },
    },

    methods: {
        continueToPage() {
            this.continueClicked = true;
        },
        showMenu() {
            this.$refs.openMenu.classList.add('showMenu')
        },
        hideMenu() {
            this.$refs.openMenu.classList.remove('showMenu')
        },
        translate(lang) {
            switch (lang) {
                case 'he':
                    this.translation = {
                        welcome: "ברוכים הבאים למוזיאון עין-דור",
                        continue: "המשך",
                        toMuseum: "למוזיאון עין-דור",
                        adultTour: "סיור במוזיאון",
                        childrenTour: "סיור ילדים",
                        quote: "'ובְחֶשְכַת הַלַּיְל בְּלִי קֶשֶׁת וְשֶׁלַח עַל סוּס קַל עֱין דּוֹרָה בָּא שָׁאוּל הַמֶּלֶךְ'",
                        quoteName: "(ש. טשרניחובסקי - 'בְּעֵין דּוֹר')",
                        welcomeText: "אנו מציעים לכם שימוש במדריך הדיגיטלי המלווה את התצוגה במוזיאון, באמצעותו תצאו למסע הכרות ומפגש בין אדם לאדמה ובין אדם לאדם באזורנו, הכרות עם החזון והמטרות של המוזיאון ועם הממצאים המוצגים. מרבית הממצאים הם בהשאלת קבע מאוצרות המדינה באמצעות רשות העתיקות. בבסיס התצוגה הארכיאולוגית נמצא העיסוק בעושר התרבותי של האזור, היותו אזור מפגש בין תרבויות וזהויות שחיו בסמיכות אלו בצד אלו לכל אורך ההיסטוריה וגם כיום. אנו מזמינים אתכם לקחת את הזמן ולאפשר לעצמכם להתבונן בפריטים, לקרוא אודותיהם ולהפליג על מפרשי הדמיון. היישומון ערוך כך שתוכלו למצוא הרחבות לנושאים, לממצאים ולחפצים המעניינים אתכם.",
                        aboutMuseum: "על המוזיאון",
                        aboutPlace: "על המקום",
                        aboutExibithion: "על התצוגה"
                    };
                    break;
                case 'ar':
                    this.translation = {
                        continue: "يكمل",
                        welcome: "مرحباً بكم في متحف عين دور",
                        toMuseum: "إلى متحف عين دور",
                        adultTour: "جولة للبالغين",
                        childrenTour: "جولة للأطفال",
                        quote: "'في ظلام الليل، بلا قوس ورمح وعلى حصان سريع، الى عين دور جاء الملك شاؤول'",
                        quoteName: "(تشرنيخوفسكي، 'في عين دور')",
                        welcomeText: "يرافق هذا المرشد الرقمي معارض المتحف ويرافقكم ايضا في جولة مشوقة للتعرف على المعرض الدائم للمتحف. من خلال التحف المعروضة في المتحف ستتعرفون على العلاقة الوثيقة بين الإنسان والأرض وبين الإنسان والإنسان في منطقتنا وستتعرفون على رؤيا المتحف وأهدافه. معظم المعروضات مستعارة بشكل دائم من خزائن الدولة في سلطة الآثار. يظهر المعرض الأثري الثراء الحضاري للمنطقة، كونها منطقة التقاء بين الحضارات والشعوب التي عاشت فيها بجانب بعضها على مر العصور وحتى اليوم، حضارات أوجدت مجموعة من القيم، بعضها يرافقنا حتى يومنا هذا. ندعوكم لمشاهدة وتامل المعروضات على مهل، بهدوء وتفحص، وقراءة المعلومات عنها والإبحار على أشرعة الخيال إلى عوالم الماضي. ستجدون في هذا الدليل مزيداً من المعلومات حول مواضيع، مكتشفات ومعروضات تهمكم.",
                        aboutMuseum: "عن المتحف",
                        aboutPlace: "عن المكان",
                        aboutExibithion: "عن المعرض"
                    };
                    break;
                case 'en':
                    this.translation = {
                        continue: "Continue",
                        welcome: "Welcome to Ein Dor Museum",
                        toMuseum: "To Ein Dor Museum",
                        adultTour: "Adult tour",
                        childrenTour: "Children tour",
                        quote: "'By cloak of night without bow or javelin... on a swift horse to Ein Dor comes Saul the King.'",
                        quoteName: "'In Ein Dor', by Shaul Tchernichovsky",
                        welcomeText: "This digital guide is meant to assist you in navigating the museum, and help you embark on a fascinating journey of discovery that will acquaint you with our permanent exhibition. Our museum’s exhibits will help unfold before you the profound connection in our particular region between humanity and earth, and between one human being and the next, and in so doing we hope to familiarize you with the museum’s philosophy and vision, and its goals. Most of the finds on display here are on permanent loan from the State of Israel’s repository of archaeological treasures, by courtesy of the Israel Antiquities Authority (IAA). The museum’s archaeological exhibits represent just a sample of the cultural richness this part of the country has to offer – its geographic position as a meeting place between cultures and identities that existed here next to each other in close proximity throughout history and till the present time – cultures that gave rise to comprehensive systems of values, some of which are embedded in us to this day. We invite you to calmly and patiently take a long, close look at these items, to read about them here, and then let your imagination carry you way back in time. The guide can also offer you additional information on particular subjects, and on the archaeological finds and objects that interest you most. Wishing you a fascinating and most enjoyable visit!\nThe Museum staff",
                        aboutMuseum: "About the Museum",
                        aboutPlace: "About the Place",
                        aboutExibithion: "About the Exhibition"
                    };
                    break;
                default:
                    // Default translation or error handling
                    break;
            }
        },

        // translate(lang) {
        //     switch (lang) {
        //         case 'he':
        //         this.translation = {

        //             welcome: "ברוכים הבאים למוזיאון עין-דור",
        //             continue: "המשך",
        //             toMuseum: "למוזיאון עין-דור",
        //             adultTour: "סיור במוזיאון",
        //             childrenTour: "סיור ילדים",
        //             quote: "'ובְחֶשְכַת הַלַּיְל בְּלִי קֶשֶׁת וְשֶלַח עַל סוּס קַל עֱין דּוֹרָה בָּא שָׁאוּל הַמֶּלֶךְ'",
        //             quoteName: "(ש. טשרניחובסקי - 'בְּעֵין דּוֹר')",
        //             welcomeText: "אנו מציעים לכם שימוש במדריך הדיגיטלי המלווה את התצוגה במוזיאון, באמצעותו תצאו למסע הכרות ומפגש בין אדם לאדמה ובין אדם לאדם באזורנו, הכרות עם החזון והמטרות של המוזיאון ועם הממצאים המוצגים. מרבית הממצאים הם בהשאלת קבע מאוצרות המדינה באמצעות רשות העתיקות. בבסיס התצוגה הארכיאולוגית נמצא העיסוק בעושר התרבותי של האזור, היותו אזור מפגש בין תרבויות וזהויות שחיו בסמיכות אלו בצד אלו לכל אורך ההיסטוריה וגם כיום. אנו מזמינים אתכם לקחת את הזמן ולאפשר לעצמכם להתבונן בפריטים, לקרוא אודותיהם ולהפליג על מפרשי הדמיון. היישומון ערוך כך שתוכלו למצוא הרחבות לנושאים, לממצאים ולחפצים המעניינים אתכם.",
        //             aboutMuseum: "על המוזיאון",
        //             aboutPlace: "על המקום",
        //             aboutExibithion: "על התצוגה"
        //         }
        //             break;
        //         case 'ar':
        //         this.translation = {
        //             continue: "يكمل",
        //             welcome: "مرحباً بكم في متحف عين دور",
        //             toMuseum: "למוזיאון עין-דור",
        //             adultTour: "جولة في المتحف",
        //             childrenTour: "جولة للطلاب",
        //             quote: "'في ظلام الليل، بلا قوس ورمح وعلى حصان سريع، الى عين دور جاء الملك شاؤول'",
        //             quoteName: "(تشرنيخوفسكي، 'في عين دور')",
        //             welcomeText: "يرافق هذا المرشد الرّقمي معارض المتحف ويرافقكم ايضا في جولة مشوّقة للتعرف على المعرض الدائم للمتحف. من خلال التحف المعروضة في المتحف ستتعرفون على العلاقة الوثيقة بين الإنسان والأرض وبين الإنسان والإنسان في منطقتنا وستتعرفون على رؤيا المتحف وأهدافه. معظم المعروضات مُستعارة بشكل دائم من خزائن الدولة في سلطة الآثار. يُظهِر المعرض الأثري الثراء الحضاري للمنطقة، كونها منطقة التقاء بين الحضارات والشعوب التي عاشت فيها بجانب بعضها على مر العصور وحتى اليوم، حضارات أوجدت مجموعة من القيم، بعضها يرافقنا حتى يومنا هذا. ندعوكم لمشاهدة وتامل المعروضات على مهل، بهدوء وتفحّص، وقراءة المعلومات عنها والإبحار على أشرعة الخيال إلى عوالم الماضي. ستجدون في هذا الدليل مزيداً من المعلومات حول مواضيع، مكتشفات ومعروضات تهمّكم.",
        //             aboutMuseum: "על המוזיאון",
        //             aboutPlace: "על המקום",
        //             aboutExibithion: "על התצוגה"
        //         }
        //             break;
        //         case 'en':
        //         this.translation = {
        //             continue: "Continue",
        //             welcome: "Welcome to",
        //             toMuseum: "Ein Dor Museum",
        //             adultTour: "Adult tour",
        //             childrenTour: "Children tour",
        //             quote: "'By cloak of night without bow or javelin... on a swift horse to Ein Dor comes Saul the King.'",
        //             quoteName: "'In Ein Dor', by Shaul Tchernichovsky",
        //         }
        //             break;
        //         default:

        //     }
        // },
        changeLanguage(lang) {
            switch (lang) {
                case 'en':
                    this.isEnglish = true
                    this.lang = "en"
                    this.translate('en')
                    this.$store.dispatch("setEnglishLang");
                    console.log("[changeLanguage] this.lang", this.lang)
                    break;
                case 'ar':
                    this.isEnglish = false
                    this.lang = "ar"
                    this.translate('ar')
                    this.$store.dispatch("setArabicLang");
                    console.log("[changeLanguage] this.lang", this.lang)
                    break;
                case 'he':
                    this.isEnglish = false
                    this.lang = "he"
                    this.translate('he')
                    this.$store.dispatch("setHebrewLang");
                    console.log("[changeLanguage] this.lang", this.lang)
                    break;
                default:

            }
        },
        startVisit() {
            this.$router.push("/visitMuseum");
        },
        startVisitChildren() {
            this.$router.push("/childrenTour");
        },

        onDismissed() {
            this.$store.dispatch("clearError");
        },
    },
};
</script>

<style scoped>
.welcomeTextClass {
    text-align-last: right;
    max-width: 320px;
    color: black;
    font-size: 17px;
    height: 20%;
    position: relative;
    top: 80px;
    font-family: 'segoeui';
}

.continueButton {
    position: absolute;
    bottom: 6%;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
    font-size: 20px;
    background-color: #63C4C3;
    border: none;
    cursor: pointer;
    z-index: 20;
    border: 6px solid white;
    border-radius: 50px;
    color: white;
    width: 180px;
    /*     
    position: absolute;
    top: 8%;
    left: 75%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    padding: 10px 20px;
    font-size: 20px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    z-index: 20;
    border-radius: 50px;
    color: white;
    width: 180px; */
}

.audioButton {
    width: 100%;
    border: 2px #63C4C3 solid;
    border-radius: 25px;
    height: 30px;
    margin-bottom: 16px;
    position: relative;
    display: flex;
    bottom: 30px;
    margin-bottom: 10px;
}

.showMenu {
    top: 0px !important;
}

.cross {
    width: 33px;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 5;
}

/* .menu {
    width: 100%;
    height: 100vh;
    background: black;
    position: fixed;
    bottom: 150vh;
    left: 0px;
    font-family: 'segoeui';
    font-size: 25px;
    font-weight: bold;
} */

.buttonsAndArrows {
    position: relative;
    bottom: 96px;
}

.background {
    background: url(../../static/img/harTavorBg.png) center center / cover no-repeat;
    height: 50vh;
    width: 100%;
}

.arrowSmall {
    height: 134px;
    width: 125px;
    position: relative;
    bottom: 60px;
}

.englishTitle {
    font-size: 18px !important;
    text-align-last: left !important;

}

.noBold {
    font-weight: 200 !important;
}

.english {
    font-size: 18px !important;
    direction: ltr;

}

.languageChoice {
    display: block;
    /* position: relative; */
    height: 37px;
    width: 91px !important;
    top: -8px;
    right: 0px;
    border: rgb(207, 207, 207) solid 5px;
    padding-top: 3px;
    color: black;
    background-color: white;
    text-align: center;
    font-size: 14px;
    border-top-left-radius: 62px;
    border-bottom-left-radius: 62px;
    border-right: none;
    font-weight: bold;
}

img {
    vertical-align: middle;
    /* border: white solid 1px;
  background: rgba(255, 255, 255, 0.4); */
    max-width: 380px;
    width: 95vw;
}

.myModal2 {
    width: 320px;
    border-radius: 10px;
    display: block;
    margin: 0px auto;
    margin-top: calc(50vh - 170px);
    background-color: rgb(84, 163, 49);
    color: white;
    border: solid 2px white;
}

.over {
    /* position: fixed; */
    top: 0px;
    font-size: 18px;
    /* left: 0px; */
    max-width: 590px;
    height: 100vh;
    /* background: url("../../static/img/navigationBackground.jpeg") no-repeat center
    center; */
    background: rgb(255, 255, 255, 0.8);
    background-size: cover;
    background-color: rgba(255, 255, 255, 0.9);
}

.btnModal {
    border: solid 2px green;
}

.buttonWhiteBorder {
    color: white;
    font-size: 23px;
    border: solid 16px white;
    background-color: transparent;
    /* position: relative;
    top: 20px; */
    height: 113px;
    box-shadow: -2px 7px 10px grey;
    font-family: 'segoeui';

}

.buttonAdults {
    background-color: #63C4C3;
    border-top-left-radius: 62px;
    border-bottom-left-radius: 62px;
    border-right: none;
}

.buttonChildren {
    background-color: #71A83F;
    border-top-right-radius: 62px;
    border-bottom-right-radius: 62px;
    border-left: none;

}

.center {
    display: block;
    margin: 0px auto;
}

/* *****************************FONT FACE************************************ */
@font-face {
    font-family: anka;
    src: url(../../static/anka/anka.woff);
}

@font-face {
    font-family: segoeui;
    src: url(../../static/segoeui/segoeui.ttf);
}

@font-face {
    font-family: Abraham;
    src: url(../../static/Abraham/Abraham-Regular.woff);
}

@font-face {
    font-family: SecularOne;
    src: url(../../static/Secular_One/SecularOne-Regular.ttf);
}

@font-face {
    font-family: noot;
    src: url(../../static/Noot/noot-aj.woff);
}

@font-face {
    font-family: danaYad;
    src: url(../../static/danaYad/danaYad.woff);
}

@font-face {
    font-family: drugulin;
    src: url(../../static/drugulin/drugulinclm-bolditalic-webfont.woff);
}

@font-face {
    font-family: dorian;
    src: url(../../static/dorian/dorian.woff);
}
</style>
